import axios from 'axios';
import LoginRequest = App.Data.Request.LoginRequest;
import EnableUserTwoFaRequest = App.Data.Request.EnableUserTwoFaRequest;
import OnboardNewUserRequest = App.Data.Request.OnboardNewUserRequest;
import GetOrganizationPageResponse = App.Data.Response.GetOrganizationPageResponse;
import WhoamiResponse = App.Data.Response.WhoamiResponse;
import SpotnanaWhoamiResponse = App.Data.Response.SpotnanaWhoamiResponse;
import ListDomainOrganizationsResponse = App.Data.Response.ListDomainOrganizationsResponse;
import ListDomainOrganizationsRequest = App.Data.Request.ListDomainOrganizationsRequest;
import CreateOrganizationUserSsoRequest = App.Data.Request.CreateOrganizationUserSsoRequest;
import StartSsoAuthorizationRequest = App.Data.Request.StartSsoAuthorizationRequest;

interface LogoutResponse {
	message: string;
}

export interface SsoUserRegisterResponse {
	redirectUrl?: string | null;
}

export interface OnboardNewUserRequestExtended extends Omit<OnboardNewUserRequest, 'legalEntityId'> {
	onboardToken: string;
	legalEntityId: number | undefined;
}

export const enableTwoFactor = async (data: EnableUserTwoFaRequest): Promise<void> => {
	const response = await axios.patch('/users/2fa/enable', data);
	return response.data;
};

export const disableTwoFactor = async (): Promise<void> => {
	const response = await axios.patch('/users/2fa/disable');
	return response.data;
};

export const login = async (requestData: LoginRequest): Promise<void> => {
	const response = await axios.post('/users/login', requestData);
	return response.data;
};

export const logout = async (): Promise<LogoutResponse> => {
	const response = await axios.post('/users/logout');
	return response.data;
};

export const whoami = async (): Promise<WhoamiResponse> => {
	const response = await axios.get<WhoamiResponse>('/users/whoami');
	return response.data;
};

export const spotnanaWhoami = async (targetPath: string | null): Promise<SpotnanaWhoamiResponse> => {
	const response = await axios.get<SpotnanaWhoamiResponse>('/spotnana/whoami?targetPath=' + targetPath);
	return response.data;
};

export const forgotPassword = async (email: string): Promise<void> => {
	const response = await axios.post('/users/password/forgot', {
		email,
	});
	return response.data;
};

export const resetPassword = async (email: string, password: string, token: string): Promise<void> => {
	const response = await axios.post('/users/password/reset', {
		email,
		password,
		token,
	});
	return response.data;
};

export const ssoUserRegister = async (
	data: CreateOrganizationUserSsoRequest & {
		provider: string;
	},
): Promise<SsoUserRegisterResponse | null> => {
	const response = await axios.post<SsoUserRegisterResponse | null>(`/auth/${data.provider}/users`, data);
	return response.data;
};

export const ssoGetUsersOrganization = async (
	data: ListDomainOrganizationsRequest & { provider: string },
): Promise<ListDomainOrganizationsResponse> => {
	const { provider, ...params } = data;
	const response = await axios.get(`/auth/${provider}/organizations`, {
		params,
	});
	return response.data;
};

//  Onboarding employee
export const registerUser = async (data: OnboardNewUserRequestExtended): Promise<OnboardNewUserRequest> => {
	const response = await axios.post(`/organizations/${data.onboardToken}/onboard-user`, data);
	return response.data;
};

export const getOrganizationLogin = async (organizationSlug: string): Promise<GetOrganizationPageResponse> => {
	const response = await axios.get(`/organization-pages/${organizationSlug}/login`);
	return response.data;
};

export const startSsoAuthorization = (authorizationUrl: string, data: StartSsoAuthorizationRequest): void => {
	const url = new URL(authorizationUrl);

	Object.entries(data).forEach(([key, value]) => {
		if (value !== undefined) {
			url.searchParams.set(key, String(value));
		}
	});

	window.location.assign(url.toString());
};
